import { EBundlesViewModel } from '@appcharge/shared-ui';
import { TemplateStudioModel } from 'common/contracts';
import { DEFAULT_BODY_BLOCKS_ORDER, EPosition } from 'constants/enums';

import { GradientDirection } from 'components/AcGradientInput/AcGraidentInput.types';
import { bundleDesigns } from 'components/TemplatesStudio/DesignsMetadata/bundles.metadata';
import { dailyBonusBadgesDesigns } from 'components/TemplatesStudio/DesignsMetadata/dailyBonusBadges.metadata';
import { popupDesigns } from 'components/TemplatesStudio/DesignsMetadata/popups.metadata';
import { progressBarsDesigns } from 'components/TemplatesStudio/DesignsMetadata/progressBars.metadata';
import { promotionDesigns } from 'components/TemplatesStudio/DesignsMetadata/promotions.metadata';
import { rewardCalendarBadgesDesigns } from 'components/TemplatesStudio/DesignsMetadata/rewardCalendarBadges.metadata';
import { rewardCalendarDesigns } from 'components/TemplatesStudio/DesignsMetadata/rewardCalendars.metadata';
import { rollingOffersDesigns } from 'components/TemplatesStudio/DesignsMetadata/rollingOffers.metadata';
import { triggeredPopupsDesigns } from 'components/TemplatesStudio/DesignsMetadata/triggeredPopups.metadata';
import { triggeredPopupsBadgesDesigns } from 'components/TemplatesStudio/DesignsMetadata/triggeredPopupsBadges.metadata';
import { ETemplateStudioLayoutOptions } from 'components/TemplatesStudio/enums';
import { buyOneGetManyDesigns } from 'components/TemplatesStudio/DesignsMetadata/buyOneGetMany.metadata';

export const defaultTemplateStudioFormValues: Partial<TemplateStudioModel> = {
  templateName: 'Template Name',
  description: '',
  tags: [],
  bodyBlocksOrder: DEFAULT_BODY_BLOCKS_ORDER,
  header: {
    showLogo: true,
    showPlayerName: false,
    showPlayerId: false,
    isSticky: false,
    backgroundOpacity: 0,
    textColor: { colorOne: '#FFFFFF' }
  },
  promotion: {
    themes: [],
    selectedDesignId: promotionDesigns.dynamic.id
  },
  bundle: {
    offersPerRow: null,
    bundleViewModel: EBundlesViewModel.LINEAR,
    themes: [],
    selectedDesignId: bundleDesigns.defaultLinear.id
  },
  popup: {
    selectedDesignId: popupDesigns.square.id
  },
  rollingOffers: {
    desktopLayout: ETemplateStudioLayoutOptions.HORIZONTAL,
    themes: [],
    selectedDesignId: rollingOffersDesigns.duo.id
  },
  buyOneGetMany: {
    desktopLayout: ETemplateStudioLayoutOptions.VERTICAL,
    themes: [],
    selectedDesignId: buyOneGetManyDesigns.defaultBuyOneGetMany.id,
    freeTilesLayout: 3,
    maxOffers: 10,
    unlimited: true
  },
  progressBar: {
    selectedDesignId: progressBarsDesigns.defaultProgressBar.id
  },
  richText: {
    text: '',
    fontColor: 'rgb(0, 0, 0)'
  },
  dailyBonusBadge: {
    themes: [],
    selectedDesignId: dailyBonusBadgesDesigns.defaultDailyBonusBadge.id
  },
  triggeredPopups: {
    selectedDesignId: triggeredPopupsDesigns.defaultTriggeredPopup.id,
    selectedBadgeDesignId:
      triggeredPopupsBadgesDesigns.defaultTriggeredPopupBadge.id,
    themes: []
  },
  rewardCalendar: {
    selectedDesignId: rewardCalendarDesigns.defaultRewardCalendar.id,
    selectedBadgeDesignId:
      rewardCalendarBadgesDesigns.defaultRewardCalendarBadge.id,
    themes: []
  },
  footer: {
    showAppchargeLogo: false,
    backgroundOpacity: 0,
    textColor: { colorOne: '#CB1010' }
  },
  brandKit: {
    fontFamily: 'Lilita One',
    buttonColor: {
      colorOne: '#7BE75A',
      colorTwo: '#58BF38',
      gradientDirection: GradientDirection.LeftToRight
    },
    buttonTextColor: '#FFFFFF',
    logo: '',
    backgroundImageMobile: '',
    backgroundImageDesktop: '',
    defaultBanner: '',
    footerDesktopImage: '',
    footerMobileImage: '',
    customArrowImage: ''
  },
  externalButtons: {
    verticalOffset: 0,
    addToHomeScreenButton: {
      active: false,
      buttonImage: '',
      iconImage: 'https://media.appcharge.com/defaults/default-store-logo.svg',
      shortcutName: 'Royal Blast Store',
      borderColor: {
        colorOne: '#ffffff'
      },
      backgroundColor: {
        colorOne: '#FFFFFF',
        colorTwo: '#FFFFFF'
      }
    },
    backToGameButton: {
      active: false,
      buttonImage: '',
      position: EPosition.RIGHT
    }
  }
};
